<!-- Dynamically show the correct language component -->
<ng-container [ngSwitch]="currentLang">
  <app-subprocessors-sk *ngSwitchCase="'sk'" [lastUpdated]="lastUpdated" [version]="version" [supportEmail]="supportEmail"></app-subprocessors-sk>
  <app-subprocessors-cz *ngSwitchCase="'cz'" [lastUpdated]="lastUpdated" [version]="version" [supportEmail]="supportEmail"></app-subprocessors-cz>
  <app-subprocessors-en *ngSwitchDefault [lastUpdated]="lastUpdated" [version]="version" [supportEmail]="supportEmail"></app-subprocessors-en>
</ng-container>
